export const setUrlSearchParam = (paramName: string, paramValue: string) => {
    const url = new URL(location.href);
    url.searchParams.set(paramName, paramValue);
    history.replaceState({}, '', url.href);
};
